module.exports = __webpack_public_path__ + "static/media/start_investing_fi.88ae800e.jpg";